import moment from 'moment/moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/dashboard'

export default {
  namespaced: true,
  state: {
    filterLoading: false,
    filterParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
      month: moment().format('M'),
      year: moment().format('YYYY'),
    },
    months: [],
    years: [],
    saleLoading: {
      overviews: false,
      brands: false,
      goals: false,
      stocks: false,
      interviewsCustomers: false,
    },
    i2SaleLoading: {
      overviews: false,
      brands: false,
      buyTypes: false,
    },
    crmLoading: {
      overviews: false,
      csi: false,
      subjects: false,
    },
    insuranceLoading: {
      sales: false,
      renewals: false,
      branches: false,
    },
    saleDashboard: {
      overviews: {
        series: [],
        categories: [],
        chartTitle: null,
        yaxis: null,
      },
      brands: {
        salesChart: {
          series: [],
          categories: [],
          colors: [],
        },
        connectionsChart: {
          series: [],
          categories: [],
          colors: [],
        },
        stocksChart: {
          series: [],
          categories: [],
          colors: [],
        },
      },
      goals: [],
      stocks: {
        brands: {
          series: [],
          labels: [],
        },
        dayDurations: {
          series: [],
          labels: [],
        },
      },
      interviewsCustomers: {
        series: [{
          name: 'Görüşmeler',
          data: [],
        }, {
          name: 'Müşteriler',
          data: [],
        }],
        labels: [],
      },
    },
    i2SaleDashboard: {
      overviews: {
        series: [],
        categories: [],
        chartTitle: null,
        yaxis: [],
      },
      brands: {
        salesChart: {
          series: [],
          categories: [],
          colors: [],
        },
        stocksChart: {
          series: [],
          categories: [],
          colors: [],
        },
        connectionsChart: {
          series: [],
          categories: [],
          colors: [],
        },
      },
      buyTypes: {
        series: [],
        labels: [],
      },
    },
    crmDashboard: {
      overviews: {
        series: [],
        labels: [],
      },
      csi: {},
      subjects: {
        series: [],
        labels: [],
      },
    },
    insuranceDashboard: {
      sales: {
        categories: [],
        series: [],
      },
      renewals: {
        items: [],
        grandTotals: {
          series: [],
          categories: [],
          colors: [],
        },
      },
      branches: {
        counts: 0,
        prim: 0,
        komisyon: 0,
        chartData: {
          series: [],
          categories: [],
          chartTitle: null,
          yaxis: [],
        },
      },
    },
  },
  getters: {
    filterLoading(state) {
      return state.filterLoading
    },
    filterParams(state) {
      return state.filterParams
    },
    months(state) {
      return state.months
    },
    years(state) {
      return state.years
    },
    saleLoading(state) {
      return state.saleLoading
    },
    saleDashboard(state) {
      return state.saleDashboard
    },
    i2SaleLoading(state) {
      return state.i2SaleLoading
    },
    i2SaleDashboard(state) {
      return state.i2SaleDashboard
    },
    crmLoading(state) {
      return state.crmLoading
    },
    crmDashboard(state) {
      return state.crmDashboard
    },
    insuranceLoading(state) {
      return state.insuranceLoading
    },
    insuranceDashboard(state) {
      return state.insuranceDashboard
    },
  },
  mutations: {
    SET_FILTER_DATA(state, data) {
      state.months = data.months
      state.years = data.years
    },
    SET_SALE_LOADING(state, data) {
      if (data.type === 'overviews') {
        state.saleLoading.overviews = data.status
      }
      if (data.type === 'brands') {
        state.saleLoading.brands = data.status
      }
      if (data.type === 'goals') {
        state.saleLoading.goals = data.status
      }
      if (data.type === 'stocks') {
        state.saleLoading.stocks = data.status
      }
      if (data.type === 'interviewsCustomers') {
        state.saleLoading.interviewsCustomers = data.status
      }
    },
    SET_I2_SALE_LOADING(state, data) {
      if (data.type === 'overviews') {
        state.i2SaleLoading.overviews = data.status
      }
      if (data.type === 'brands') {
        state.i2SaleLoading.brands = data.status
      }
      if (data.type === 'buyTypes') {
        state.i2SaleLoading.buyTypes = data.status
      }
    },
    SET_CRM_LOADING(state, data) {
      if (data.type === 'overviews') {
        state.crmLoading.overviews = data.status
      }
      if (data.type === 'csi') {
        state.crmLoading.csi = data.status
      }
      if (data.type === 'subjects') {
        state.crmLoading.subjects = data.status
      }
    },
    SET_INSURANCE_LOADING(state, data) {
      if (data.type === 'sales') {
        state.insuranceLoading.sales = data.status
      }
      if (data.type === 'renewals') {
        state.insuranceLoading.renewals = data.status
      }
      if (data.type === 'branches') {
        state.insuranceLoading.branches = data.status
      }
    },
    SET_SALE_DATA(state, data) {
      if (data.type === 'overviews') {
        state.saleDashboard.overviews = data.data
      }
      if (data.type === 'brands') {
        state.saleDashboard.brands = data.data
      }
      if (data.type === 'goals') {
        state.saleDashboard.goals = data.data
      }
      if (data.type === 'stocks') {
        state.saleDashboard.stocks = data.data
      }
      if (data.type === 'interviewsCustomers') {
        state.saleDashboard.interviewsCustomers = data.data
      }
    },
    SET_I2_SALE_DATA(state, data) {
      if (data.type === 'overviews') {
        state.i2SaleDashboard.overviews = data.data
      }
      if (data.type === 'brands') {
        state.i2SaleDashboard.brands = data.data
      }
      if (data.type === 'buyTypes') {
        state.i2SaleDashboard.buyTypes = data.data
      }
    },
    SET_CRM_DATA(state, data) {
      if (data.type === 'overviews') {
        state.crmDashboard.overviews = data.data
      }
      if (data.type === 'csi') {
        state.crmDashboard.csi = data.data
      }
      if (data.type === 'subjects') {
        state.crmDashboard.subjects = data.data
      }
    },
    SET_INSURANCE_DATA(state, data) {
      if (data.type === 'sales') {
        state.insuranceDashboard.sales = data.data
      }
      if (data.type === 'renewals') {
        state.insuranceDashboard.renewals = data.data
      }
      if (data.type === 'branches') {
        state.insuranceDashboard.branches = data.data
      }
    },
    SET_FILTER_LOADING(state, data) {
      state.filterLoading = data
    },
    /* RESET MUTATIONS */
    RESET_SALE_DASHBOARD(state) {
      state.saleDashboard = {
        overviews: {
          series: [],
          categories: [],
          chartTitle: null,
          yaxis: null,
        },
        brands: {
          salesChart: {
            series: [],
            categories: [],
            colors: [],
          },
          connectionsChart: {
            series: [],
            categories: [],
            colors: [],
          },
          stocksChart: {
            series: [],
            categories: [],
            colors: [],
          },
        },
        goals: [],
        stocks: {
          brands: {
            series: [],
            labels: [],
          },
          dayDurations: {
            series: [],
            labels: [],
          },
        },
        interviewsCustomers: {
          series: [{
            name: 'Görüşmeler',
            data: [],
          }, {
            name: 'Müşteriler',
            data: [],
          }],
          labels: [],
        },
      }
    },
  },
  actions: {
    getFilterItems({ commit }) {
      commit('SET_FILTER_LOADING', true)
      axiosIns
        .post(`${ROOT_URL}/filterData`)
        .then(response => {
          commit('SET_FILTER_DATA', response.data)
          commit('SET_FILTER_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getSales({ commit }, params) {
      commit('SET_SALE_LOADING', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/sales?type=${params.type}`, data)
        .then(response => {
          commit('SET_SALE_DATA', {
            type: params.type,
            data: response.data,
          })
          commit('SET_SALE_LOADING', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
    getI2Sales({ commit }, params) {
      commit('SET_I2_SALE_LOADING', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/i2Sales?type=${params.type}`, data)
        .then(response => {
          commit('SET_I2_SALE_DATA', {
            type: params.type,
            data: response.data,
          })
          commit('SET_I2_SALE_LOADING', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
    getCrm({ commit }, params) {
      commit('SET_CRM_LOADING', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/crm?type=${params.type}`, data)
        .then(response => {
          commit('SET_CRM_DATA', {
            type: params.type,
            data: response.data,
          })
          commit('SET_CRM_LOADING', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
    getInsurance({ commit }, params) {
      commit('SET_INSURANCE_LOADING', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/insurances?type=${params.type}`, data)
        .then(response => {
          commit('SET_INSURANCE_DATA', {
            type: params.type,
            data: response.data,
          })
          commit('SET_INSURANCE_LOADING', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
  },
}
